/**
 * Single source of truth for identity, links and feature flags.
 * Changing name / socials / email / YouTube happens HERE — never in components.
 */
export const site = {
  name: "ABMax",
  owner: "Ainārs Bērziņš",
  tagline: "Games, tools & other endeavors",
  description:
    "ABMax is the umbrella for everything Ainārs Bērziņš builds solo: Threefold Rift, an idle auto-battler with a Path of Exile-shaped heart, the Athletic Records Journal, an offline-first training log, and TasteTrove, a food tracker with a worth-to-buy formula.",
  /** Update when the domain is registered and live. */
  url: "https://abmax.lv",
  email: "ABMaxHQ@gmail.com",
  blog: {
    name: "Personal Blog",
    url: "https://ainarsberzins.com",
    feed: "https://ainarsberzins.com/feed/",
  },
  socials: [] as { label: string; url: string }[],
  /** Flip to true the day the channel exists — Nav and Footer light up on their own. */
  showYouTube: false,
  youTubeUrl: "https://www.youtube.com/@ABMax",
} as const;
